module.exports = __webpack_public_path__ + "img/home-emergency-2.dceade5e.png";